import { useSyncExternalStore } from 'react';
import type { RemoteScore } from '../messages';
import { scoresUpdated } from '../RoomState';

export interface LeaderboardEntry {
  id: string;
  name: string;
  score: number;
  totalScore: number;
  color: number;
  finished: boolean;
  connected: boolean;
}

type ScoresMap = Record<string, RemoteScore>;
type ScoresHandler = (scores: ScoresMap) => void;

let currentScores: ScoresMap = {};
let leaderboard: LeaderboardEntry[] = [];

export function toLeaderboard(scores: ScoresMap): LeaderboardEntry[] {
  return Object.entries(scores)
    .map(([id, data]) => ({
      id,
      name: data.name,
      score: data.score,
      totalScore: data.totalScore,
      color: data.color ?? 0,
      finished: data.finished ?? false,
      connected: data.connected ?? true,
    }))
    .sort((a, b) => b.score - a.score || a.name.localeCompare(b.name));
}

scoresUpdated.subscribe((scores) => {
  currentScores = scores;
  leaderboard = toLeaderboard(scores);
});

function subscribe(callback: () => void): () => void {
  const handler: ScoresHandler = () => callback();
  scoresUpdated.subscribe(handler);
  return () => scoresUpdated.unsubscribe(handler);
}

export function useMultiplayerScores() {
  return useSyncExternalStore(
    subscribe,
    () => leaderboard,
    () => leaderboard,
  );
}

export function useMultiplayerScoresMap() {
  return useSyncExternalStore(
    subscribe,
    () => currentScores,
    () => currentScores,
  );
}
